import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BaseRequest } from '../models/base-request.model';
import { Observable } from 'rxjs';
import { BaseResponse } from '../models/base-response.model';
import { CookieService } from './cookie.service';
import { CustomTrackingService } from './custom-tracking.service';

@Injectable({ providedIn: 'root' })
export class HttpService {
  httpClient = inject(HttpClient);
  cookieService = inject(CookieService);
  customTrackingService = inject(CustomTrackingService);
  apiUrl = 'api/';

  constructor() {
    if (!this.cookieService.check('SessionId')) {
      this.cookieService.setSessionId();
    }
    this.customTrackingService.registerCookie();
  }

  get<T>(url: string): Observable<BaseResponse<T>> {
    return this.httpClient.get<BaseResponse<T>>(this.apiUrl + url, {
      withCredentials: true,
    });
  }

  post<T extends BaseRequest>(
    url: string,
    body: T,
    withToken: boolean = false
  ): Observable<BaseResponse<any>> {
    // Add custom header to indicate token should be included (will be removed by interceptor)
    if (withToken) {
      return this.httpClient.post<BaseResponse<any>>(this.apiUrl + url, body, {
        withCredentials: true,
        headers: { 'X-Include-Token': 'true' },
      });
    }

    return this.httpClient.post<BaseResponse<any>>(this.apiUrl + url, body, {
      withCredentials: true,
    });
  }
}
